export const continueAccountLinking = () => {
  if (window.location.href.includes('step=ecommerce')) {
    const params = new URL(window.location.href).searchParams;
    const integration = params.get('integration');
    const success = params.get('success')?.toLocaleLowerCase() === 'true';

    if (integration) {
      const url = new URL(window.location.href);
      url.searchParams.delete('step');
      url.searchParams.delete('integration');
      url.searchParams.delete('success');
      window.history.replaceState({}, '', url.toString());
      return {
        integration: integration,
        success: success
      };
    }
  }
  return null;
};
